/**
 * A filter operator, valued by Flexmonster's query key. A Condition takes the equality, text, date and relative keys,
 * a Value filter takes top, bottom and the equality and range keys.
 */
export enum PivotFilterOperatorEnum {
  equal = 'equal',
  not_equal = 'not_equal',
  begin = 'begin',
  not_begin = 'not_begin',
  end = 'end',
  not_end = 'not_end',
  contain = 'contain',
  not_contain = 'not_contain',
  greater = 'greater',
  greater_equal = 'greater_equal',
  less = 'less',
  less_equal = 'less_equal',
  between = 'between',
  not_between = 'not_between',
  before = 'before',
  before_equal = 'before_equal',
  after = 'after',
  after_equal = 'after_equal',
  last = 'last',
  current = 'current',
  next = 'next',
  top = 'top',
  bottom = 'bottom',
}
